// Action Types
export const SET_SWIMMING_POOL_COMPANIES = "SET_SWIMMING_POOL_COMPANIES";
export const SET_SWIMMING_POOL_COMPANY = "SET_SWIMMING_POOL_COMPANY";
export const SET_INSPECTION_TEMPLATES = "SET_INSPECTION_TEMPLATES";
export const SET_INSPECTION_TEMPLATE = "SET_INSPECTION_TEMPLATE";
export const SET_TEMPLATE_ITEMS = "SET_TEMPLATE_ITEMS";
export const SET_INSPECTIONS = "SET_INSPECTIONS";
export const SET_INSPECTION = "SET_INSPECTION";
export const SET_DASHBOARD_STATS = "SET_DASHBOARD_STATS";
export const ZWEMBADINSPECTIES_ERROR = "ZWEMBADINSPECTIES_ERROR";
export const SET_LOADING = "SET_LOADING";

function handleResponse(response) {
  if (response.ok) {
    return response.json();
  } else {
    let error = new Error(response.statusText);
    error.response = response.statusText;
    throw error;
  }
}

// Action Creators
export function setSwimmingPoolCompanies(results) {
  return {
    type: SET_SWIMMING_POOL_COMPANIES,
    results,
  };
}

export function setSwimmingPoolCompany(results) {
  return {
    type: SET_SWIMMING_POOL_COMPANY,
    results,
  };
}

export function setInspectionTemplates(results) {
  return {
    type: SET_INSPECTION_TEMPLATES,
    results,
  };
}

export function setInspectionTemplate(results) {
  return {
    type: SET_INSPECTION_TEMPLATE,
    results,
  };
}

export function setTemplateItems(results) {
  return {
    type: SET_TEMPLATE_ITEMS,
    results,
  };
}

export function setInspections(results) {
  return {
    type: SET_INSPECTIONS,
    results,
  };
}

export function setInspection(results) {
  return {
    type: SET_INSPECTION,
    results,
  };
}

export function setDashboardStats(results) {
  return {
    type: SET_DASHBOARD_STATS,
    results,
  };
}

export function zwembadinspectiesError(error) {
  return {
    type: ZWEMBADINSPECTIES_ERROR,
    payload: error,
  };
}

export function setLoading(loading) {
  return {
    type: SET_LOADING,
    loading,
  };
}

// Swimming Pool Companies API Calls
export function fetchSwimmingPoolCompanies() {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch("/api/swimming-pools/companies", {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        return dispatch(setSwimmingPoolCompanies(results.results));
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij ophalen zwembaden"));
      });
  };
}

export function getSwimmingPoolCompany(id) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/swimming-pools/companies/${id}`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        return dispatch(setSwimmingPoolCompany(results.result));
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij ophalen zwembad"));
      });
  };
}

export function saveSwimmingPoolCompany(data) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch("/api/swimming-pools/companies", {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        dispatch(fetchSwimmingPoolCompanies());
        return results;
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij opslaan zwembad"));
      });
  };
}

export function updateSwimmingPoolCompany(id, data) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/swimming-pools/companies/${id}`, {
      method: "put",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        dispatch(fetchSwimmingPoolCompanies());
        return results;
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij updaten zwembad"));
      });
  };
}

export function deleteSwimmingPoolCompany(id) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/swimming-pools/companies/${id}`, {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        dispatch(fetchSwimmingPoolCompanies());
        return results;
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij verwijderen zwembad"));
      });
  };
}

// Inspection Templates API Calls
export function fetchInspectionTemplates() {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch("/api/inspection-templates/templates", {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        return dispatch(setInspectionTemplates(results.results));
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij ophalen templates"));
      });
  };
}

export function getInspectionTemplate(id) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/inspection-templates/templates/${id}`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        dispatch(setInspectionTemplate(results.result));
        return results.result; // Return the template data
      })
      .catch((err) => {
        dispatch(setLoading(false));
        dispatch(zwembadinspectiesError("Fout bij ophalen template"));
        return null;
      });
  };
}

export function saveInspectionTemplate(data) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch("/api/inspection-templates/templates", {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        dispatch(fetchInspectionTemplates());
        return results;
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij opslaan template"));
      });
  };
}

export function updateInspectionTemplate(id, data) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/inspection-templates/templates/${id}`, {
      method: "put",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        // Update ook de enkele template in de store zodat formulieren up-to-date blijven
        if (results.result) {
          dispatch(setInspectionTemplate(results.result));
        }
        dispatch(fetchInspectionTemplates());
        return results;
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij updaten template"));
      });
  };
}

export function duplicateTemplate(id) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/inspection-templates/templates/${id}/duplicate`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        dispatch(fetchInspectionTemplates());
        return results;
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij dupliceren template"));
      });
  };
}

export function fetchTemplateItems(templateId) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/inspection-templates/templates/${templateId}/items`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        return dispatch(setTemplateItems(results.results));
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij ophalen template items"));
      });
  };
}

export function updateTemplateItems(templateId, items) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/inspection-templates/templates/${templateId}/items`, {
      method: "put",
      body: JSON.stringify({ items }),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        dispatch(fetchTemplateItems(templateId));
        return results;
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij updaten template items"));
      });
  };
}

// Inspections API Calls
export function fetchInspections(filters = {}) {
  return (dispatch) => {
    dispatch(setLoading(true));
    const queryParams = new URLSearchParams(filters).toString();
    return fetch(`/api/inspections/inspections?${queryParams}`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        return dispatch(setInspections(results.results));
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij ophalen inspecties"));
      });
  };
}

export function getInspection(id) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/inspections/inspections/${id}`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        return dispatch(setInspection(results.result));
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij ophalen inspectie"));
      });
  };
}

export function saveInspection(data) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch("/api/inspections/inspections", {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        return results;
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij opslaan inspectie"));
      });
  };
}

export function updateInspection(id, data) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/inspections/inspections/${id}`, {
      method: "put",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        return results;
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij updaten inspectie"));
      });
  };
}

export function autoSaveInspection(id, data) {
  return (dispatch) => {
    return fetch(`/api/inspections/inspections/${id}/autosave`, {
      method: "put",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        console.error("Auto-save fout:", err);
      });
  };
}

export function changeInspectionStatus(id, status) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/inspections/inspections/${id}/status`, {
      method: "patch",
      body: JSON.stringify({ status }),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        dispatch(getInspection(id));
        return results;
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij wijzigen status"));
      });
  };
}

export function completeInspection(id, data) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/inspections/inspections/${id}/complete`, {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        return results;
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij afronden inspectie"));
      });
  };
}

export function generateReport(id) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/inspections/inspections/${id}/report`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        return results;
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return dispatch(zwembadinspectiesError("Fout bij genereren rapport"));
      });
  };
}

// Report Version Management
export function saveReportVersion(id, notes) {
  return (dispatch) => {
    return fetch(`/api/inspections/inspections/${id}/report/versions`, {
      method: "post",
      body: JSON.stringify({ notes }),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij opslaan versie"));
      });
  };
}

export function getReportVersions(id) {
  return (dispatch) => {
    return fetch(`/api/inspections/inspections/${id}/report/versions`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij ophalen versies"));
      });
  };
}

export function getReportVersion(id, versionId) {
  return (dispatch) => {
    return fetch(`/api/inspections/inspections/${id}/report/versions/${versionId}`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij ophalen versie"));
      });
  };
}

export function fetchDashboardStats() {
  return (dispatch) => {
    return fetch("/api/inspections/dashboard/stats", {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return dispatch(setDashboardStats(results.result));
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij ophalen statistieken"));
      });
  };
}

// Report Photo Actions
export function uploadReportPhoto(id, file) {
  return (dispatch) => {
    const formData = new FormData();
    formData.append('file', file);

    return fetch(`/api/inspections/inspections/${id}/report-photo`, {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: formData,
    })
      .then(handleResponse)
      .then((results) => {
        // Update inspection with new report photo
        dispatch(getInspection(id));
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij uploaden rapport foto"));
      });
  };
}

export function deleteReportPhoto(id) {
  return (dispatch) => {
    return fetch(`/api/inspections/inspections/${id}/report-photo`, {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        // Update inspection after deletion
        dispatch(getInspection(id));
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij verwijderen rapport foto"));
      });
  };
}

// Email Template Actions
export function getEmailTemplates() {
  return (dispatch) => {
    return fetch("/api/email-templates", {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij ophalen email sjablonen"));
      });
  };
}

export function getEmailTemplate(id) {
  return (dispatch) => {
    return fetch(`/api/email-templates/${id}`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij ophalen email sjabloon"));
      });
  };
}

export function createEmailTemplate(data) {
  return (dispatch) => {
    return fetch("/api/email-templates", {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij aanmaken email sjabloon"));
      });
  };
}

export function updateEmailTemplate(id, data) {
  return (dispatch) => {
    return fetch(`/api/email-templates/${id}`, {
      method: "put",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij bijwerken email sjabloon"));
      });
  };
}

export function deleteEmailTemplate(id) {
  return (dispatch) => {
    return fetch(`/api/email-templates/${id}`, {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij verwijderen email sjabloon"));
      });
  };
}

export function sendReportEmail(inspectionId, data) {
  return (dispatch) => {
    // Log de grootte van de data die verzonden wordt
    const jsonData = JSON.stringify(data);
    console.log("📧 Verzenden email data grootte:", jsonData.length, "bytes");
    console.log("📧 PDF base64 lengte:", data.pdfBase64?.length || 0, "bytes");

    return fetch(`/api/inspections/inspections/${inspectionId}/send-email`, {
      method: "post",
      body: jsonData,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        console.error("Email verzend fout:", err);
        return dispatch(zwembadinspectiesError("Fout bij verzenden email"));
      });
  };
}

// Certificaten Actions
export function getCertificaten() {
  return (dispatch) => {
    return fetch("/api/certificaten", {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij ophalen certificaten"));
      });
  };
}

export function getCertificaat(id) {
  return (dispatch) => {
    return fetch(`/api/certificaten/${id}`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij ophalen certificaat"));
      });
  };
}

export function createCertificaat(data) {
  return (dispatch) => {
    return fetch("/api/certificaten", {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij aanmaken certificaat"));
      });
  };
}

export function updateCertificaat(id, data) {
  return (dispatch) => {
    return fetch(`/api/certificaten/${id}`, {
      method: "put",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij bijwerken certificaat"));
      });
  };
}

export function deleteCertificaat(id) {
  return (dispatch) => {
    return fetch(`/api/certificaten/${id}`, {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij verwijderen certificaat"));
      });
  };
}

export function uploadCertificaatPdf(file) {
  return (dispatch) => {
    const formData = new FormData();
    formData.append('file', file);

    return fetch("/api/certificaten/upload-pdf", {
      method: "post",
      headers: {
        Authorization: localStorage.getItem("token"),
      },
      body: formData,
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij uploaden PDF template"));
      });
  };
}

// Conclusie Items Actions
export function getConclusieItems() {
  return (dispatch) => {
    return fetch("/api/conclusie-items", {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij ophalen conclusie items"));
      });
  };
}

export function createConclusieItem(data) {
  return (dispatch) => {
    return fetch("/api/conclusie-items", {
      method: "post",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij aanmaken conclusie item"));
      });
  };
}

export function updateConclusieItem(id, data) {
  return (dispatch) => {
    return fetch(`/api/conclusie-items/${id}`, {
      method: "put",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij bijwerken conclusie item"));
      });
  };
}

export function deleteConclusieItem(id) {
  return (dispatch) => {
    return fetch(`/api/conclusie-items/${id}`, {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij verwijderen conclusie item"));
      });
  };
}

export function saveConclusies(inspectionId, data) {
  return (dispatch) => {
    return fetch(`/api/inspections/inspections/${inspectionId}/conclusies`, {
      method: "put",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij opslaan conclusies"));
      });
  };
}

// Publiek Rapport Actions
export function generatePublicToken(id) {
  return (dispatch) => {
    return fetch(`/api/inspections/inspections/${id}/public-token`, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij genereren publieke link"));
      });
  };
}

export function revokePublicToken(id) {
  return (dispatch) => {
    return fetch(`/api/inspections/inspections/${id}/public-token`, {
      method: "delete",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    })
      .then(handleResponse)
      .then((results) => {
        return results;
      })
      .catch((err) => {
        return dispatch(zwembadinspectiesError("Fout bij intrekken publieke link"));
      });
  };
}

// Publiek rapport ophalen (geen authenticatie nodig)
export function getPublicReport(token) {
  return (dispatch) => {
    dispatch(setLoading(true));
    return fetch(`/api/public/report/${token}`, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(handleResponse)
      .then((results) => {
        dispatch(setLoading(false));
        return results;
      })
      .catch((err) => {
        dispatch(setLoading(false));
        return { success: false, message: "Rapport niet gevonden of link is verlopen" };
      });
  };
}
